
export const paymentGatewayMenuDef = [
    {
        name: 'menu.payment_gateway_details',
        resource: 'payment_gateway_details',
        icon:'fa fa-user',
        url: 'payment_gateway_details',
        auto_crud: true,
        breadcrumb: 'Payment Gateway Detail',
        check_permission: false
    },
    {
        name: "menu.transaction_details",
        resource: "epayment_transaction_details",
        icon: "fa fa-user",
        url: "epayment_transaction_details",
        auto_crud: true,
        showMenu: true,
        check_permission: false
    },
    {
        name: "menu.epayment_transaction_format",
        resource: "epayment_transactions_format",
        icon: "fa fa-user",
        url: "epayment_transactions_format",
        auto_crud: true,
        showMenu: true,
        check_permission: false
    },
    {
        name: "menu.transaction_format",
        resource: "epayment_transactions_pos",
        icon: "fa fa-user",
        url: "epayment_transactions_pos",
        auto_crud: true,
        showMenu: true,
        check_permission: false
    },
    {
        name: "menu.online_payment_status",
        resource: "epayment_transactions",
        icon: "fa fa-user",
        url: "epayment_transactions",
        auto_crud: true,
        showMenu: true,
        check_permission: false
    },
    

]